export const typography = {
	size: {
		display_2xl: "72px", //4.5rem
		display_xl: "60px", //3.75rem
		display_lg: "48px", //3rem
		display_md: "36px", //2.25rem
		display_sm: "32px", //2rem
		display_xs: "24px", //1.5rem
		text_xl: "20px", //1.25rem
		text_lg: "18px", //1.125rem
		text_md: "16px", //1rem
		text_sm: "14px", //0.875rem
		text_xs: "12px", //0.75rem
	},
	weight: {
		regular: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
	},
	lineHeight: {
		display_2xl: "90px",
		display_xl: "72px",
		display_lg: "60px",
		display_md: "44px",
		display_sm: "40px",
		display_xs: "32px",
		text_xl: "30px",
		text_lg: "28px",
		text_md: "24px",
		text_sm: "20px",
		text_xs: "18px",
	},
};
